module.exports = __webpack_public_path__ + "img/wnpActive.7d25ef2b.svg";